/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */

// @ts-ignore
import $ from 'jquery';

// importing for the side effects, but TS requires files to be modules
export {};

if (typeof (window as any).global === 'undefined') {
    (window as any).global = window;
}

// @ts-ignore
global.$ = global.jQuery = $;
